import React from 'react';
import { useNavigate } from 'react-router-dom';

const DashboardHeader = ({ period, onPeriodChange }) => {
  const navigate = useNavigate();
  const periods = [
    { value: '30', label: '30 Tage' },
    { value: '90', label: '90 Tage' },
    { value: 'all', label: 'Gesamt' },
  ];

  return (
    <header className='dashboard-header'>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img src="https://zba.academy/webinar/images/zbalogo2.png" alt="ZBA Academy" style={{ height: '34px', width: 'auto' }} />
        <div>
          <div style={{ fontFamily: 'var(--font-heading)', fontSize: '17px', fontWeight: 700, color: '#1e2b38', lineHeight: 1.1 }}>Buchungs-Dashboard</div>
          <div style={{ fontSize: '11px', color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-ui)', fontWeight: 500 }}>ZBA - Webinar-Tracking</div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button
          onClick={() => navigate('/crm')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            padding: '7px 14px', borderRadius: '10px',
            border: '1.5px solid #6366f1', background: '#6366f1',
            cursor: 'pointer', fontSize: '13px', fontWeight: 600,
            color: 'white', fontFamily: 'var(--font-ui)',
            transition: 'all 150ms ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#4f46e5'; e.currentTarget.style.borderColor = '#4f46e5'; }}
          onMouseLeave={e => { e.currentTarget.style.background = '#6366f1'; e.currentTarget.style.borderColor = '#6366f1'; }}
        >
          📊 CRM & Deals
        </button>

        <button
          onClick={() => navigate('/events-admin')}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px',
            background: '#FF4500', color: 'white', border: 'none', borderRadius: '10px',
            cursor: 'pointer', fontSize: '13px', fontWeight: 600, fontFamily: 'var(--font-ui)',
            whiteSpace: 'nowrap' }}>
          🎪 Events
        </button>

        <button
          onClick={() => navigate('/admin/step2work')}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px',
            background: '#3E4954', color: 'white', border: 'none', borderRadius: '10px',
            cursor: 'pointer', fontSize: '13px', fontWeight: 600, fontFamily: 'var(--font-ui)',
            whiteSpace: 'nowrap' }}>
          🤝 Step2Work
        </button>

        <button
          onClick={() => navigate('/analytics')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            padding: '7px 14px', borderRadius: '10px',
            border: '1.5px solid #dde1e7', background: 'white',
            cursor: 'pointer', fontSize: '13px', fontWeight: 600,
            color: '#3E4954', fontFamily: 'var(--font-ui)',
            transition: 'all 150ms ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#3E4954'; e.currentTarget.style.color = 'white'; e.currentTarget.style.borderColor = '#3E4954'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.color = '#3E4954'; e.currentTarget.style.borderColor = '#dde1e7'; }}
        >
          <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <polygon points='22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3'/>
          </svg>
          Funnel-Analyse
        </button>

        <button
          onClick={() => navigate('/admin/bookings')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            padding: '7px 14px', borderRadius: '10px',
            border: '1.5px solid #dde1e7', background: 'white',
            cursor: 'pointer', fontSize: '13px', fontWeight: 600,
            color: '#3E4954', fontFamily: 'var(--font-ui)',
            transition: 'all 150ms ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#d97706'; e.currentTarget.style.color = 'white'; e.currentTarget.style.borderColor = '#d97706'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.color = '#3E4954'; e.currentTarget.style.borderColor = '#dde1e7'; }}
        >
          <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <rect x='3' y='4' width='18' height='18' rx='2' ry='2'/><line x1='16' y1='2' x2='16' y2='6'/><line x1='8' y1='2' x2='8' y2='6'/><line x1='3' y1='10' x2='21' y2='10'/>
          </svg>
          Buchungen verwalten
        </button>

        <button
          onClick={() => navigate('/settings')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            padding: '7px 14px', borderRadius: '10px',
            border: '1.5px solid #dde1e7', background: 'white',
            cursor: 'pointer', fontSize: '13px', fontWeight: 600,
            color: '#3E4954', fontFamily: 'var(--font-ui)',
            transition: 'all 150ms ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#1e2b38'; e.currentTarget.style.color = 'white'; e.currentTarget.style.borderColor = '#1e2b38'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.color = '#3E4954'; e.currentTarget.style.borderColor = '#dde1e7'; }}
        >
          <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <circle cx='12' cy='12' r='3'/>
            <path d='M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14'/>
          </svg>
          Einstellungen
        </button>

        <div style={{
          display: 'flex', alignItems: 'center', gap: '4px',
          background: '#f5f6f8', borderRadius: '12px', padding: '4px',
          border: '1px solid #dde1e7',
        }}>
          {periods?.map(p => (
            <button
              key={p?.value}
              type='button'
              onClick={() => onPeriodChange(p?.value)}
              style={{
                padding: '6px 14px', borderRadius: '8px', border: 'none', cursor: 'pointer',
                fontSize: '13px', fontWeight: 600, fontFamily: 'var(--font-ui)',
                transition: 'all 200ms ease',
                background: period === p?.value ? '#3E4954' : 'transparent',
                color: period === p?.value ? '#ffffff' : 'var(--color-muted-foreground)',
                boxShadow: period === p?.value ? '0 1px 4px rgba(62, 73, 84, 0.2)' : 'none',
              }}
            >
              {p?.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
